import React, { useCallback, useState } from 'react'
import { X } from 'react-feather'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { tabs } from './index'
import { Base, ButtonEmpty } from '../Button'
import { AutoColumn } from 'components/Column'
import { ReactComponent as Menu } from '../../assets/svg/menu.svg'
import arrowUpUrl from 'assets/svg/arrow_up.svg'
import { ExternalLink } from 'theme'
import { StyledDialogOverlay } from 'components/Modal'
import { UserInfoTabRoute, UserInfoTabs } from 'pages/User'

const ToggleMenuButton = styled(Base)`
  background: none;
  width: auto;
  :active,
  :focus {
    border: none;
  }
`

const Overlay = styled(StyledDialogOverlay)`
  &[data-reach-dialog-overlay] {
    z-index: 11;
    top: 0;
    background-color: ${({ theme }) => theme.bg2};
    max-height: calc(100vh - ${({ theme }) => theme.headerHeight});
    overflow: auto;
  }
`

const TabMobile = styled(NavLink)<{ isSubTab?: boolean }>`
  font-size: 28px;
  font-weight: 500;
  color: ${({ theme }) => theme.text1};
  width: 100%;
  padding: 16px 30px;
  cursor: pointer;
  text-decoration: none;
  ${({ isSubTab, theme }) =>
    isSubTab
      ? `
  font-size: 16px;
  padding: 8px 32px;
  color: ${theme.text2};
  `
      : ''}
`
const SubTabMobile = styled(ExternalLink)`
  font-size: 16px;
  line-height: 24px;
  padding: 8px 32px;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  :focus,
  :active,
  :hover {
    color: ${({ theme }) => theme.text1};
  }
`

const ToggleTabMobile = styled.div<{ isopen: 'true' | 'false' }>`
  font-size: 28px;
  font-weight: 500;
  color: ${({ theme }) => theme.text1};
  width: 100%;
  padding: 16px 30px;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  :after {
    content: '';
    width: 14px;
    height: 8px;
    background: url(${arrowUpUrl});
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%) ${({ isopen }) => (isopen === 'true' ? '' : 'rotate(180deg)')};
  }
`

const CloseButton = styled(ButtonEmpty)`
  position: absolute;
  color: #252525;
  top: 16px;
  right: 25px;
  width: auto;
  height: auto;
`

const CreateButton = styled(ButtonEmpty)`
  width: auto;
  height: auto;
  font-size: 28px;
  font-weight: 500;
  padding: 16px 30px;
  justify-content: flex-start;
`

function ToggleTab({ children, title }: { children: JSX.Element | string; title: string }) {
  const [isOpen, setIsOpen] = useState(false)
  const handleClick = useCallback(() => {
    setIsOpen(!isOpen)
  }, [setIsOpen, isOpen])

  return (
    <>
      <ToggleTabMobile title={title} onClick={handleClick} isopen={isOpen ? 'true' : 'false'}>
        {title}
      </ToggleTabMobile>
      {isOpen && <>{children}</>}
    </>
  )
}

export default function ToggleMenu({ onCreate }: { onCreate: () => void }) {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = useCallback(() => setIsOpen(true), [])
  const handleClose = useCallback(() => setIsOpen(false), [])

  const handleCreate = useCallback(() => {
    onCreate()
    setIsOpen(false)
  }, [onCreate])

  return (
    <>
      <ToggleMenuButton onClick={handleOpen}>
        <Menu style={{ height: 30, width: 24, fill: '#252525' }} />
      </ToggleMenuButton>
      {isOpen && (
        <Overlay>
          <CloseButton onClick={handleClose}>
            <X size={24} />
          </CloseButton>
          <AutoColumn style={{ marginTop: 40, width: '100vw', alignSelf: 'flex-start' }}>
            {tabs.map(({ title, route, subTab }) =>
              subTab ? (
                <ToggleTab key={title} title={title}>
                  <>
                    {subTab &&
                      subTab.map(({ title, route, link, titleContent }) => {
                        return link ? (
                          <SubTabMobile key={title} href={link}>
                            {title}
                          </SubTabMobile>
                        ) : (
                          <TabMobile key={title} to={`/${route}`} onClick={() => setIsOpen(!isOpen)} isSubTab={true}>
                            {titleContent ?? title}
                          </TabMobile>
                        )
                      })}
                  </>
                </ToggleTab>
              ) : (
                <TabMobile key={title} to={`/${route}`} onClick={() => setIsOpen(!isOpen)}>
                  {title}
                </TabMobile>
              )
            )}

            <ToggleTab title={'My Profile'}>
              <>
                <TabMobile to={'/profile/' + UserInfoTabs.POSITION} onClick={() => setIsOpen(!isOpen)}>
                  {UserInfoTabRoute[UserInfoTabs.POSITION]}
                </TabMobile>
                <TabMobile to={'/profile/' + UserInfoTabs.INDEX} onClick={() => setIsOpen(!isOpen)}>
                  {UserInfoTabRoute[UserInfoTabs.INDEX]}
                </TabMobile>
                <TabMobile to={'/profile/' + UserInfoTabs.LOCKER} onClick={() => setIsOpen(!isOpen)}>
                  {UserInfoTabRoute[UserInfoTabs.LOCKER]}
                </TabMobile>
                <TabMobile to={'/profile/' + UserInfoTabs.NFT} onClick={() => setIsOpen(!isOpen)}>
                  {UserInfoTabRoute[UserInfoTabs.NFT]}
                </TabMobile>
              </>
            </ToggleTab>
            <CreateButton onClick={handleCreate}>+ Create</CreateButton>
          </AutoColumn>
        </Overlay>
      )}
    </>
  )
}
